import { useQuery } from "@tanstack/react-query";
import { CustomerService } from "./_request";

export const useQueryCustomersForSelect = (params?: any) => {
  return useQuery({
    queryKey: ["queryCustomer"],
    queryFn: async () => CustomerService.getAllCustomerForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.["@id"],
        }));
      } else {
        return [];
      }
    },
  });
};

export const useQueryCustomerCategory = (params?: any) => {
  return useQuery({
    queryKey: ["queryCustomerCategory"],
    queryFn: async () => CustomerService.getCustomerCategory(params),
    select(data) {
      if(Array.isArray(data?.data?.member)) {
        return data?.data?.member.map((item: any) => ({
          //...item,
          label: item?.name,
          value: item?.["@id"],
        }));
      } else {
        return [];
      }
    }
  })
}
